<template>
  <div>
    <section class="page-section bg-white" data-section-name="blog">
        <div class="container mx-auto">
          <h2 class="text-2.5xl lg:text-3.5xl color-black font-black text-center">
            {{ $t('shared.discover_our_blog') }}
          </h2>
          <v-row class="my-8">
            <v-col
              v-for="(post, index) in blogPosts"
              :key="index"
              :md="4"
              class="p-4"
            >
              <app-card-blog
                :image="post.image"
                :date="post.date_published"
                :title="post.title"
                :description="post.description"
                :link="post.link"
              ></app-card-blog>
            </v-col>
          </v-row>
        </div>
        <div class="container mx-auto">
          <v-btn
            rounded
            elevation="0"
            color="secondary"
            class="avm-btn avm-btn--large avm-btn--large--white mx-auto block py-3 font-bold"
            @click.stop="() => goBlog()"
          >
            {{ $t('shared.find_out_more') }}
          </v-btn>
          </div>
      </section>
  </div>
</template>
<script>
import axios from 'axios';
import HorizontalScroll from 'vue-horizontal-scroll';
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'

export default {
  data() {
    return {
      blogPosts: []
    }
  },
  beforeMount() {
        this.getPosts()
    },
  methods: {
    getPosts(){
      let me =this;
      let url = '/lastposts';
      axios.get(url).then(function (response) {
          me.blogPosts = response.data;
      })
      .catch(function (error) {
          // TODO: handle error
          console.log(error);
      });
    },
    goBlog(){
      window.location.href = '/blog';
    },
  },
}
</script>
<style lang="scss" scoped>
.page-section{
   padding: 6.25rem 0;
}

.v-btn__content {
  color: white !important;
}
</style>
